export class GenericTableHeaderOptions {
  ShowSearch?: boolean;
  SearchPlaceholder?: string;
  EnableAddButton?: boolean;
  FilterItems?: FilterItem[];
  SortItems?: SortItem[];
  DefaultSort?: string;
  DefaultDesc?: boolean;
  DateItem?: DateItem;
  DateRequired?: boolean;
  EnableExport?: boolean;
  EnableSelectAll?: boolean;
  EnableImport?: boolean;
  EnableClear?: boolean;
  EnableView?: boolean;
  DropDownOptions?: DropdownOption[];
  ToggleFilters?: FilterItem[];
  ChangeSession?: boolean;
}

export class FilterItem {
  Name: string;
  Values?: string[];
  DefaultValue?: any;
}

export class DropDownOptions {}

export class DropdownOption {
  MultipleDropdowns?: boolean;
  Label: string;
  options: any[];
  attribute: string;
}

export class SortItem {
  Name: string;
  Display: string;
}

export class DateItem {
  Title?: string;
  Singular: boolean;
  Type?: 'time' | 'day' | 'month' | 'year';
  StartDate?: string;
  EndDate?: string;
}

export class RefreshData {
  Search: string;
  Sort: string;
  Desc: boolean;
  Filters: { Name: string; value: string }[];
  FromDate: string;
  ToDate: string;
}
